"use client"

import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Loader2 } from "lucide-react"

interface ConfirmationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  message: string
  description?: string
  onConfirm: () => Promise<void> | void
  onCancel: () => void
  loading?: boolean
  translations?: (key: string) => string
}

export function ConfirmationDialog({
  open,
  onOpenChange,
  title,
  message,
  description,
  onConfirm,
  onCancel,
  loading = false,
  translations
}: ConfirmationDialogProps) {
  // Translation helper function
  const t = (key: string, fallback?: string) => {
    if (!translations) return fallback || key
    const result = translations(key)
    return result === key ? (fallback || key) : result
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>
            {message}
            {description && <span className="block mt-2">{description}</span>}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={loading}>
            {t('functions.cancel', 'Cancelar')}
          </Button>
          <Button 
            variant="destructive" 
            onClick={onConfirm} 
            disabled={loading}
            className="gap-2"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            {t('functions.confirm', 'Confirmar')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}